import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './support-data.reducer';
import { SupportDataEffects } from './support-data.effects';
import { SupportDataDispatcher } from './support-data.dispatcher';
import { SupportDataStore } from './support-data.store';
import { SupportDataService } from './support-data.service';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([SupportDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class SupportDataModule {
  static forRoot(): ModuleWithProviders<SupportDataModule> {
    return {
      ngModule: SupportDataModule,
      providers: [SupportDataDispatcher, SupportDataService, SupportDataStore],
    };
  }
}
